import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=55003dca&scoped=true&"
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "./PageView.vue?vue&type=style&index=0&id=55003dca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55003dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55003dca')) {
      api.createRecord('55003dca', component.options)
    } else {
      api.reload('55003dca', component.options)
    }
    module.hot.accept("./PageView.vue?vue&type=template&id=55003dca&scoped=true&", function () {
      api.rerender('55003dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/PageView.vue"
export default component.exports